<script setup lang="ts">
import IconStar from '@zyro-inc/site-modules/components/icons/IconStar.vue';
import IconStarOutline from '@zyro-inc/site-modules/components/icons/IconStarOutline.vue';
import IconStarHalfFilled from '@zyro-inc/site-modules/components/icons/IconStarHalfFilled.vue';
import { computed } from 'vue';

const props = defineProps<{
	rating: number,
	isHalfAllowed?: boolean,
}>();

const fullStarsCount = computed(() => Math.floor(props.rating));
const hasHalfStar = computed(() => props.isHalfAllowed && props.rating % 1 >= 0.5);
const outlinedStarsCount = computed(() => 5 - fullStarsCount.value - (hasHalfStar.value ? 1 : 0));
</script>

<template>
	<div class="product-rating">
		<IconStar
			v-for="i in fullStarsCount"
			:key="`full-${i}`"
			data-qa="icon-star"
		/>
		<IconStarHalfFilled
			v-if="hasHalfStar"
			data-qa="icon-star-half"
		/>
		<IconStarOutline
			v-for="i in outlinedStarsCount"
			:key="`outline-${i}`"
			data-qa="icon-star-outline"
		/>
	</div>
</template>

<style lang="scss" scoped>
.product-rating {
	display: flex;
	align-items: center;
	gap: 4px;
	color: var(--body-color);
}
</style>
